export default "__VITE_ASSET__79456f39__"